export default __webpack_public_path__ + "static/media/fight.48847dbc.png";